import _ from 'lodash'
import ProfileSnapshot from './profile-summary/profile-snapshot'
import {
  LegalConditionDisclaimerMarketConduct,
  LegalConditionDisclaimerMarketConductNoAddtionalContract,
} from 'quick-quote/product-flexi-health/benefit-illustration/components/flexi-health-legal-disclaimer'
import ProductBenefits from './product-benefits/product-benefits'
import PolicyValueTable from './policy-value/policy-value-table'
import PolicyValueGioTable from 'quick-quote/product-common/benefit-illustration/policy-value-gio/policy-value-table'
import PolicyValueGlobalIndexTable from './policy-value-global-index/policy-value-table'
import PolicyValueIndexLinkedTable from './policy-value-index-linked/policy-value-table'
import InvestmentBenefit from './investment-benefit/investment-benefit'
import InvestmentBenefitGlobalIndex1 from './investment-benefit-global-index-1/investment-benefit'
import InvestmentBenefitGlobalIndex2 from './investment-benefit-global-index-2/investment-benefit'
import InvestmentBenefitIndexLinked1 from './investment-benefit-index-linked-1/investment-benefit'
import InvestmentBenefitIndexLinked2 from './investment-benefit-index-linked-2/investment-benefit'
import RiderBenefits from 'quick-quote/product-common/benefit-illustration/components/rider-benefits'
import { SidebarMenu } from 'quick-quote/components'
import { isNil } from 'core/service/lib/type-check'
import { FormFeedback, FormGroup } from 'reactstrap'

import { Redirect } from 'react-router-dom'
import PATH from 'quick-quote/constants/path'
import MESSAGES from 'core/data-model/constants/validation-messages'
import VALUES from 'core/data-model/constants/values'
import BIMESSAGES from 'core/data-model/constants/bi-messages'
import TaxGioDeductionBenefit from 'quick-quote/product-common/benefit-illustration/components/tax-gio-deduction-benefit'
import TaxConsentDeductionBenefit from 'quick-quote/product-common/benefit-illustration/components/tax-consent-deduction-benefit'

export const summaryHeaderWithCode = ({ displayProduct, riders }) => {
  const name = _.get(displayProduct, 'displayName', '')
  const riderPlanCode = _.get(displayProduct, 'basicPlanCode', '')
  switch (riderPlanCode) {
    case BIMESSAGES.ULTIMATE_GROWTH_CODE_2010:
      return `${name} ${BIMESSAGES.ULTIMATE_GROWTH_QQ_2010} (${riderPlanCode})`
    case BIMESSAGES.ULTIMATE_GROWTH_CODE_2515:
      return `${name} ${BIMESSAGES.ULTIMATE_GROWTH_QQ_2515} (${riderPlanCode})`
    case BIMESSAGES.ULTIMATE_GROWTH_CODE_2525:
      return `${name} ${BIMESSAGES.ULTIMATE_GROWTH_QQ_2525} (${riderPlanCode})`
    default:
      return `${name} (${riderPlanCode})`
  }
}

const summaryHeader = ({ displayProduct }) => {
  if (displayProduct) {
    if (displayProduct.basicPlanCode === 'W80F06') {
      return displayProduct.name
    }

    return VALUES.PRODUCT_GIO.includes(displayProduct.code)
      ? VALUES.PREFIX_PRODUCT_NAME_THAI + ' ' + displayProduct.nameThai
      : displayProduct.nameThai
  } else {
    return ''
  }
}

const BenefitIllustration = ({
  displayProduct,
  riders,
  genderLabel,
  age,
  calculatedCoveragePeriod,
  calculatedPaymentPeriod,
  sumAssured$,
  basicPremium$,
  totalPremium,
  totalRiderPremium,
  selectedModelFactorLabel,
  hasNonLevelRider,
  hasShowDisclaimerRiderAsterisk,
  coveragePlanStartDate,
  legalDisclaimerEndDate,
  policyValue,
  benefitSummary,
  canProceedToBenefitIllustration,
  isBlockedPdfGeneration,
  isBlockedEnteringESub,
  taxDeduction,
  isBancAgent,
  isNewAsteriskOfSummaryMainContract,
  isReviseQQ,
  isCheckHaveRiderCampaignDiscountActive,
  riderCampaignDiscountBIMessage,
}) => {
  if (!canProceedToBenefitIllustration) {
    return <Redirect to={PATH.PRODUCT_SELECTION} push />
  } else if (isNil(displayProduct)) return <div id="benefit-illustration-invalid" />
  else {
    return (
      <div id="benefit-illustration">
        <div className="content">
          <ProfileSnapshot
            displayProduct={displayProduct}
            riders={riders}
            genderLabel={genderLabel}
            age={age}
            calculatedCoveragePeriod={calculatedCoveragePeriod}
            calculatedPaymentPeriod={calculatedPaymentPeriod}
            policyValue={policyValue}
            sumAssured={sumAssured$.value}
            basicPremium={basicPremium$.value}
            totalPremium={totalPremium}
            totalRiderPremium={totalRiderPremium}
            selectedModelFactorLabel={selectedModelFactorLabel}
            hasNonLevelRider={hasNonLevelRider}
            hasShowDisclaimerRiderAsterisk={hasShowDisclaimerRiderAsterisk}
            profileSummaryHeader={summaryHeaderWithCode}
            summaryTableHeader={summaryHeader}
            isNewAsteriskOfSummaryMainContract={isNewAsteriskOfSummaryMainContract}
            isReviseQQ={isReviseQQ}
            isCheckHaveRiderCampaignDiscountActive={isCheckHaveRiderCampaignDiscountActive}
            riderCampaignDiscountBIMessage={riderCampaignDiscountBIMessage}
          />

          <ProductBenefits
            displayProduct={displayProduct}
            sumAssured={sumAssured$.value}
            basicPremium={basicPremium$.value}
            calculatedPaymentPeriod={calculatedPaymentPeriod}
            calculatedCoveragePeriod={calculatedCoveragePeriod}
            policyValue={policyValue}
            benefitSummaryHeader={({ displayProduct }) => displayProduct.nameThai}
          />

          {riders.length > 0 && <RiderBenefits />}

          {VALUES.PRODUCT_GIO.includes(displayProduct.code) ? (
            Object.values(VALUES.GLOBAL_INDEX_16_6_CODE).includes(displayProduct.code) ? (
              <PolicyValueGlobalIndexTable policyValue={policyValue} basicPlan={displayProduct} />
            ) : Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(displayProduct.code) ||
              Object.values(VALUES.INDEX_LINKED_15_8_CODE).includes(displayProduct.code) ? (
              <PolicyValueIndexLinkedTable policyValue={policyValue} basicPlan={displayProduct} />
            ) : (
              <PolicyValueGioTable policyValue={policyValue} basicPlan={displayProduct} />
            )
          ) : (
            <PolicyValueTable policyValue={policyValue} basicPlan={displayProduct} />
          )}

          {!VALUES.TERM_LIFE_PLANCODE_EXCEPT_CALCULATE_INVESTMENT_BENEFIT.includes(displayProduct.code) &&
            !Object.values(VALUES.GLOBAL_INDEX_16_6_CODE).includes(displayProduct.code) &&
            !Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(displayProduct.code) &&
            !Object.values(VALUES.INDEX_LINKED_15_8_CODE).includes(displayProduct.code) && (
              <InvestmentBenefit
                displayProduct={displayProduct}
                coveragePlanStartDate={coveragePlanStartDate}
                legalDisclaimerEndDate={legalDisclaimerEndDate}
              />
            )}

          {Object.values(VALUES.GLOBAL_INDEX_16_6_CODE).includes(displayProduct.code) && (
            <>
              <InvestmentBenefitGlobalIndex1
                displayProduct={displayProduct}
                coveragePlanStartDate={coveragePlanStartDate}
                legalDisclaimerEndDate={legalDisclaimerEndDate}
              />
              <InvestmentBenefitGlobalIndex2
                displayProduct={displayProduct}
                coveragePlanStartDate={coveragePlanStartDate}
                legalDisclaimerEndDate={legalDisclaimerEndDate}
              />
            </>
          )}

          {(Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(displayProduct.code) ||
            Object.values(VALUES.INDEX_LINKED_15_8_CODE).includes(displayProduct.code)) && (
              <>
                <InvestmentBenefitIndexLinked1
                  displayProduct={displayProduct}
                  coveragePlanStartDate={coveragePlanStartDate}
                  legalDisclaimerEndDate={legalDisclaimerEndDate}
                  policyValue={policyValue}
                />
                <InvestmentBenefitIndexLinked2
                  displayProduct={displayProduct}
                  coveragePlanStartDate={coveragePlanStartDate}
                  legalDisclaimerEndDate={legalDisclaimerEndDate}
                />
              </>
            )}

          {VALUES.PRODUCT_GIO.includes(displayProduct.code) ? (
            <TaxGioDeductionBenefit taxDeduction={taxDeduction} productCode={displayProduct.code} />
          ) : (
            <TaxConsentDeductionBenefit taxDeduction={taxDeduction} />
          )}

          {VALUES.PRODUCT_GIO.includes(displayProduct.code) ? (
            <LegalConditionDisclaimerMarketConductNoAddtionalContract
              startDate={coveragePlanStartDate}
              endDate={legalDisclaimerEndDate}
              isBancAgent={isBancAgent}
            />
          ) : (
            <LegalConditionDisclaimerMarketConduct
              startDate={coveragePlanStartDate}
              endDate={legalDisclaimerEndDate}
              isBancAgent={isBancAgent}
            />
          )}

          {isBlockedEnteringESub ? (
            <FormGroup className="has-warning">
              <FormFeedback className={'eligibility-message attached-icon'}>
                <div> {MESSAGES.RULE_ENTER_ESUB_PREREQUISITE} </div>
              </FormFeedback>
            </FormGroup>
          ) : (
            ''
          )}
        </div>
        {Object.values(VALUES.GLOBAL_INDEX_16_6_CODE).includes(displayProduct.code) ||
          Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(displayProduct.code) ||
          Object.values(VALUES.INDEX_LINKED_15_8_CODE).includes(displayProduct.code) ? (
          <SidebarMenu
            parentSelector=".example"
            childSelector=".name .example-name"
            riderMenu={{
              text: BIMESSAGES.POLICY_VALUE_TABLE,
              to: 'policy-value',
              isSub: false,
            }}
            mainMenu={[
              {
                text: VALUES.PRODUCT_PLANCODE_NO_RIDER.includes(displayProduct.code)
                  ? BIMESSAGES.SUMMARY_OF_MAIN_CONTRACTS
                  : BIMESSAGES.SUMMARY_OF_MAIN_AND_ADDITIONAL_CONTRACTS,
                id: 'profile-summary',
                isSub: false,
              },
              {
                text: 'รายละเอียดของสัญญาหลัก',
                id: 'product-benefits',
                isSub: false,
              },
              {
                text: 'สรุปผลประโยชน์',
                id: 'investment-benefit-2',
                isSub: false,
              },
              {
                text: BIMESSAGES.LEGAL_DISCLAIMER,
                id: 'legal-disclaimer-market-conduct',
                isSub: false,
              },
            ]}
          />
        ) : (
          <SidebarMenu
            mainMenu={[
              {
                text: VALUES.PRODUCT_PLANCODE_NO_RIDER.includes(displayProduct.code)
                  ? BIMESSAGES.SUMMARY_OF_MAIN_CONTRACTS
                  : BIMESSAGES.SUMMARY_OF_MAIN_AND_ADDITIONAL_CONTRACTS,
                id: 'profile-summary',
                isSub: false,
              },
              {
                text: 'รายละเอียดของสัญญาหลัก',
                id: 'product-benefits',
                isSub: false,
              },
              {
                text: BIMESSAGES.POLICY_VALUE_TABLE,
                id: 'policy-value',
                isSub: false,
              },
              {
                text: BIMESSAGES.INVESTMENT_BENEFITS,
                id: 'investment-benefit',
                isSub: false,
                isShow: !VALUES.TERM_LIFE_PLANCODE_EXCEPT_CALCULATE_INVESTMENT_BENEFIT.includes(displayProduct.code),
              },
              {
                text: BIMESSAGES.LEGAL_DISCLAIMER,
                id: 'legal-disclaimer-market-conduct',
                isSub: false,
              },
            ]}
          />
        )}
      </div>
    )
  }
}

export default BenefitIllustration
